
export const logoGeneration = {
    toolName: 'Logo生成器',
    toolDescription: '使用AI技术生成专业的Logo设计，只需输入描述即可创建独特的品牌标识',
    promptTemplate: '请为我设计一个现代简约风格的Logo，包含以下元素：',
    
    // 提示词输入相关
    promptLabel: 'Logo描述',
    promptDescription: '描述您想要创建的Logo',
    promptPlaceholder: '请输入您的Logo描述...',
    
    // 提示词建议
    promptSuggestions: {
      title: '提示词建议',
      business: '商业Logo：现代简约的科技公司Logo，蓝色调，包含字母"T"',
      creative: '创意Logo：艺术工作室Logo，彩色笔刷效果，创意字体',
      minimal: '极简Logo：极简主义咖啡店Logo，棕色调，咖啡豆元素',
      tech: '科技Logo：AI科技公司Logo，未来感设计，蓝绿渐变'
    },
    
    // 生成参数
    parameters: {
      style: '风格',
      colors: '颜色',
      elements: '元素',
      modern: '现代',
      classic: '经典',
      minimal: '极简',
      creative: '创意'
    },
    
    // 结果相关
    results: {
      title: 'Logo生成结果',
      downloading: '正在下载Logo...',
      downloadSuccess: 'Logo下载成功！',
      downloadFailed: 'Logo下载失败，请重试',
      regenerating: '正在重新生成...',
      saveToCollection: '保存到收藏'
    },
    
    // 错误消息
    errors: {
      emptyPrompt: '请输入Logo描述',
      generationFailed: 'Logo生成失败，请重试',
      networkError: '网络错误，请检查连接',
      serverError: '服务器错误，请稍后重试'
    }
  };
